import { combineReducers } from 'redux';
import application from './application';
import dimension from './dimension';
import material from './material';
import loads from './loads';
import design from './design';
import calculate from './calculate';
import editor from './editor';

export default combineReducers({
  application,
  dimension,
  material,
  loads,
  design,
  calculate,
  editor
});



// WEBPACK FOOTER //
// ./src/reducers/selectors/index.js